import { Button, DropMenu, Icon } from '@roo/roo'
import React, { useState } from 'react'
import { IBillItem } from '../../utils/types'
import { downloadFile } from '@/common/utils'
import { fetchBillDownlad } from '../../utils/api'
import { useRequest } from 'ahooks'
import { useTranslation } from '@sailor/i18n-web'
import LoadingIcon from '@/components/LoadingIcon'

const DownloadBill = ({ record }: { record: IBillItem}) => {
  const { t } = useTranslation()

  const { loading, run: handleDownload } = useRequest(downloadFn, { manual: true })
  async function downloadFn (billFileId: string) {
    const res = await fetchBillDownlad({ billFileId })
    downloadFile(res.fileUrl)
  }

  const downloadMenu = record.billFileList?.map(item => ({
    label: item.language,
    onClick: () => handleDownload(item.fileId),
  }))

  const disabled = loading || !downloadMenu?.length

  return (
    <DropMenu menu={downloadMenu} disabled={disabled}>
      <Button type="brand-text" disabled={disabled}>
        {
          loading
            ?  <LoadingIcon />
            :  <div > <Icon name="export"  size={20}/> {t('e_pc_download', '下载')} </div>
        }
      </Button>
    </DropMenu>
  )
}

export default DownloadBill